<!-- /**
 * 订单管理 交易订单
 */ -->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品分类列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <br />

    <el-form  :model="formInline" :inline="true" v-show="isShowSearch">
      <el-form-item label="商品分类名称">
          <treeselect
            v-model="formInline.name"
            :options="classOptions"
            :normalizer="normalizerTwo"
            :show-count="true"
            width="220px"
            placeholder="选择商品分类名称"
          />
<!--        <el-select-->
<!--          size="small"-->
<!--          clearable-->
<!--          filterable-->
<!--          v-model="formInline.name"-->
<!--          placeholder="请选择商品分类名称"-->
<!--        >-->
<!--          <el-option-->
<!--            v-for="item in proTypeListOption"-->
<!--            :key="item.id + '-smlxkey'"-->
<!--            :label="item.name"-->
<!--            :value="item.name"-->
<!--          >-->
<!--          </el-option>-->
<!--        </el-select>-->
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        <!-- <el-button size="small" type="primary" @click="handleunit()">部门设置</el-button> -->
      </el-form-item>
    </el-form>
    <el-row>
      <el-button size="small"
                       type="primary"
                       icon="el-icon-plus" @click="handleEdit">新增</el-button>
    </el-row>
<!--    <div class="hide_search_box">-->
<!--      <el-tooltip class="hide_search" effect="dark" :content="!isShowSearch?'显示搜索':'隐藏搜索'" placement="top-start">-->
<!--        <el-button icon="el-icon-search" size="small"-->
<!--                   type="primary"-->
<!--                   plain-->
<!--                   @click="hideSearch" circle></el-button>-->
<!--      </el-tooltip>-->
<!--    </div>-->
    <el-table size="small" row-key="id" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="主键" show-overflow-tooltip>
      </el-table-column>
    <el-table-column sortable prop="name" label="分类名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="order" label="分类排序" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable label="分类图标" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-image
                style="width: 80px; height: 50px"
                :src="scope.row.imageOssUrl"
                :preview-src-list="[scope.row.imageOssUrl]">
            </el-image>
          </template>
      </el-table-column>
      <el-table-column sortable label="分类是否推荐" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isRecommend"
            @change="recommendChange($event, scope.row)"
            :active-value="'1'"
            size="mini"
            :inactive-value="'0'"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column sortable label="分类推荐图片" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.recommendImageOssUrl"
            style="width: 80px; height: 50px"
            :src="scope.row.recommendImageOssUrl"
            :preview-src-list="[scope.row.recommendImageOssUrl]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createDate" label="创建时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.createDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="updateDate" label="修改时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.updateDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
<!--    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>-->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @close="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-row>
          <el-col :span="15">
            <el-form-item label="父级分类" prop="parentId">
              <treeselect
                v-model="editForm.parentId"
                :options="classOptions"
                :normalizer="normalizer"
                :show-count="true"

                placeholder="选择父级分类"
              />
<!--              @select="nodeselect"-->
            </el-form-item>
            <el-form-item label="分类名称" prop="name">
              <el-input size="small" v-model.trim="editForm.name" @change="change" placeholder="请输入分类名称" :maxlength="nameLength"></el-input>
            </el-form-item>
            <el-form-item label="分类排序" prop="order">
              <el-input size="small" v-model.trim="editForm.order" @change="change" placeholder="请输入分类排序"></el-input>
            </el-form-item>

            <el-form-item label="分类图标" prop="imageOss">
                <el-upload
                  v-loading="uploading"
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :http-request="nationalUploadRequest"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="editForm.imageOss" :src="editForm.imageOss" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div slot="tip" class="img_size_tip">避免影响小程序内显示效果，请上传：20px*20px大小或等比例图片</div>
               </el-upload>
            </el-form-item>
            <el-form-item label="分类推荐" prop="isRecommend">
              <el-switch
                v-model="editForm.isRecommend"
                active-value="1"
                size="mini"
                inactive-value="0"
                active-text="是"
                inactive-text="否"
                @change="recommendChange2($event, editForm.isRecommend)"
              >
              </el-switch>
            </el-form-item>
            <el-form-item label="分类推荐图片" prop="recommendImageNo">
              <el-upload
                v-loading="uploading"
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :http-request="nationalUploadRequest2"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.recommendImageOssUrl" :src="editForm.recommendImageOssUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="img_size_tip">避免影响小程序内显示效果，请上传：345px*120px大小或等比例图片</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getClassiFicationById,
  classiFicationList,
  addClassiFication,
  delClassiFication,
  editClassiFication,
  GoodsRecommend,
  getClassiFicationTypeList,
} from '../../api/basisMG'
import {upimg} from '@/api/userMG'
import Pagination from '../../components/Pagination'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  data() {
    return {
      loading: false, //是显示加载
      isShowSearch: true,
      uploading:false,
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      editForm: {
        name:'',
        parentId:0,
        order:null,
        imageNo:null
      },
      formInline: {
        // page: 1,
        // limit: 10,
      },
      rules:{

        name:[ { required: true, message: '请输入分类名称', trigger: 'change' },],
        order:[ { required: true, message: '请输入分类排序', trigger: 'change' },]
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      proTypeListOption:[],
      classOptions:[]
    }
  },
  // 注册组件
  components: {
    Pagination,
    Treeselect
  },
  computed:{
    nameLength() {
      let type = this.editForm.parentId == 0 ? 1: 2
      return type === 1 ? 5:7
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    // this.getDictByTypeId()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getDictByTypeId() {
      getClassiFicationTypeList().then((res) => {
        this.proTypeListOption = res.body; // 获取分类下拉列表
        this.classOptions = [];
        let menu = { 'id': 0, 'name': '主类目', children: [] };
        menu.children = res.body;
        console.log(menu)
        this.classOptions.push(menu);
      });
    },
    beforeAvatarUpload(file) {
        // console.log(file,'图片文件before');
        const isJPG = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('只能上传jpg或png格式!');
        }
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
        // return isLt2M;
      },
       //  分类图标自定义上传
    nationalUploadRequest(filePath){
      this.uploading = true
        let formData = new FormData()
        formData.append('file',filePath.file)
      upimg(formData).then(res=>{
        if(res.rsp_code==200){
          this.uploading = false
          this.editForm.imageNo = res.body.imageNo; //提交参数 图片标识串
          this.editForm.imageOss = res.body.ossUrl; // 上传后回显
        }else{
          this.uploading = false
          this.$message.error('上传失败!');
        }
      })
    },
    nationalUploadRequest2(filePath){
      this.uploading = true
      let formData = new FormData()
      formData.append('file',filePath.file)
      upimg(formData).then(res=>{
        if(res.rsp_code==200){
          this.uploading = false
          this.editForm.recommendImageNo = res.body.imageNo; //提交参数 图片标识串
          this.editForm.recommendImageOssUrl = res.body.ossUrl; // 上传后回显
        }else{
          this.uploading = false
          this.$message.error('上传失败!');
        }
      })
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
       classiFicationList(parameter)
        .then(res => {
          this.loading = false
          if (res.rsp_code !== 200) {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })

          } else {
            this.listData = res.body
            this.getDictByTypeId()
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.page
            // this.pageparm.pageSize = this.formInline.limit
            // this.pageparm.total = res.body.total
          }
        })
        .catch(err => {
          this.loading = false
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page=1
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        // this.editForm = row
        this.editForm.name = row.name
        this.editForm.parentId = row.parentId
        this.editForm.id = row.id
        this.editForm.order = row.order
        this.editForm.imageOss = row.imageOssUrl
        this.editForm.imageNo = row.imageNo
        this.editForm.isRecommend = row.isRecommend
        this.editForm.recommendImageNo = row.recommendImageNo
        this.editForm.recommendImageOssUrl = row.recommendImageOssUrl
        console.log(this.editForm)
      } else {
        this.title = '添加'
        this.editForm.isRecommend = '0';
        this.editForm.parentId = 0;
        this.editForm.imageOss = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          let subType = this.title == '修改'?editClassiFication:addClassiFication
          subType(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.rsp_code==200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delClassiFication(row.id)
            .then(res => {
              if (res.rsp_code==200) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false

      this.$refs[formName].resetFields()
      this.editForm= {
        name:'',
        parentId:0,
        order:null,
        imageNo:null
      }
    },
    change(){
      this.$forceUpdate();  //强制刷新
    },
    recommendChange($event, row) {
      let par = {
        recommend: $event,
        id: row.id,
      };

      let data = {...row}
      delete data.children
      console.log(data)
      // if (row.underCarriage == 0) {
      //   this.$message.warning("未上架商品不能设置推荐！");
      //   row.isRecommend = 1;
      //   return;
      // }
      let text = row.isRecommend == 1 ? "设为推荐" : "取消推荐";
      this.$confirm("确定要把" + '"' + row.name + '"' + text + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return editClassiFication(data);
        })
        .then((res) => {
          if (res.rsp_code == 200) {
            this.$message.success(text + "成功！");
            this.getdata(this.formInline);
          }
        })
        .catch(function () {
          row.isRecommend = row.isRecommend === 0 ? 1 : 0;
        });
    },
    recommendChange2($event, isRecommend) {
      this.editForm.isRecommend = isRecommend
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children
      };
    },
    normalizerTwo(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.name,
        label: node.name,
        children: node.children
      };
    },
    // 展示隐藏搜索
    hideSearch() {
      this.isShowSearch = !this.isShowSearch
    },
  }
}
</script>
<style>
 .el-upload__tip{
   line-height: 20px;
 }
 .avatar-uploader .el-upload {
     border: 1px dashed #d9d9d9;
     border-radius: 6px;
     cursor: pointer;
     position: relative;
     overflow: hidden;
   }
   .avatar-uploader .el-upload:hover {
     border-color: #409EFF;
   }
   .avatar-uploader-icon {
     font-size: 28px;
     color: #8c939d;
     width: 100px;
     height: 100px;
     line-height: 100px;
     text-align: center;
   }
   .avatar {
     width: 100px;
     height: 100px;
     display: block;
   }
   .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
     width: 100px;
     height: 100px;
     line-height: 100px;
     text-align: center;
   }
 </style>
<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.inline-block{
  display: inline-block;
  width: 20%;
}
.vue-treeselect{
  width: 220px;
}
</style>







// WEBPACK FOOTER //
// src/views/product/typeList.vue